import _ from "lodash";
import React, { Component } from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter,  Form, 
    FormGroup, UncontrolledTooltip, Card, CardBody, CardHeader,
} from "reactstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { getAdminUsers, deleteUser, updateUser, resetPasswordFunc ,setPageInfo} from "../../actions/actionAdminUser";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import "react-table/react-table.css";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { renderCheckbox, renderField, required, password } from "../../utils/formValidations.js";
import { NotificationManager } from "react-notifications";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table";
import moment from "moment";
import { http } from "../../middleware/httpMiddleware";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Users",path:"/adminUser",isActive: true}
];

const validate = values => {
    const errors = {};
    if (values.newPassword !== values.confirmPassword) {
        errors.confirmPassword = "Passwords Do Not Match";
    }
    return errors;
};

class AdminUser extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            modal: false,
            modalreset: false,
            pages: 1,
            users: [],
            userId: null,
            userName: null,
            password: "",
            confirmPassword: "",
            show:false,
        };

        this.resetConfirm = this.resetConfirm.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.toggle1 = this.toggle1.bind(this);
        this.toggle = this.toggle.bind(this);
    }
    
    resetConfirm(userId,userName){
        this.setState({modalreset: !this.state.modalreset,
            userId: userId,
            userName: userName
        });
    }

    resetPassword(userData){
        let currentUser = this.state.users.find(user => user.user_id === this.state.userId);
        currentUser.password = userData.newPassword;
        this.props.resetPasswordFunc(currentUser).
            then(() => this.handlePasswordResetSuccess()).
            catch(() => this.handlePasswordResetFailure());
    }

    handlePasswordResetSuccess(){
        const {errorResetPasswordMessage} = this.props;
        if(errorResetPasswordMessage) {
            NotificationManager.error(errorResetPasswordMessage,"Reset Password", 3000);
        }
        else {
            this.props.initialize({ password: "" });
            this.setState({modalreset: false});
            NotificationManager.success("Successfully Reset Password","Reset Password",3000);
        }
    }

    handlePasswordResetFailure(){
        const {resetPasswordError} = this.props;
        if(resetPasswordError){
            NotificationManager.error(resetPasswordError,"Reset Password", 3000);
        }
        else {
            NotificationManager.error("Failed to Reset Password","Reset Password", 3000);
        }
    }

    deleteConfirm(userId,userName){
        this.setState({modal: !this.state.modal,
            userId: userId,
            userName: userName});
    }

    deleteUser(){
        this.props.deleteUser(this.state.userId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteUserErrorMessage} = this.props;
        if(deleteUserErrorMessage) {
            NotificationManager.error(deleteUserErrorMessage,"Delete User", 3000);
        }
        else{
            this.setState({modal: false});
            this.props.getAdminUsers({
                page: 0,
                pageSize: 5
            });
            NotificationManager.success("Successfully Deleted User","Delete User", 3000);
        }
    }

    handleDeleteError(){
        const {deleteUsersError} = this.props;
        if(deleteUsersError){
            NotificationManager.error(deleteUsersError,"Delete User", 3000);
        }
        else{
            NotificationManager.error("Failed to Delete User","Delete User", 3000);
        }
    }

    toggle1(){
        this.setState({modalreset: !this.state.modalreset});
        this.props.initialize({  newPassword: "" , confirmPassword: "" });
    }

    toggle(){
        this.setState({modal: !this.state.modal});
    }

    render() {
        if (this.props.getUsersLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const { handleSubmit} = this.props;

        const columns = [
            {
                type: "text",
                accessor: "username",
                name: "User Name",
                filterable: true,
                sortable: true
            },
            {
                type: "date",
                accessor: "created",
                name: "Created",
                filterable: true,
                sortable: true,
            },
            {
                type: "flag",
                accessor: "anonymous",
                name: "Anonymous",
                filterable: true,
                sortable: true
            },
            {
                type: "flag",
                accessor: "locked",
                name: "Locked",
                filterable: true,
                sortable: true
            },
            {
                type: "flag",
                accessor: "disabled",
                name: "Disabled",
                filterable: true,
                sortable: true
            },
            {
                type: "date",
                accessor: "last_session",
                name: "Last Session",
                filterable: true,
                sortable: true,
                cell: (data) => <div>{moment(data.value).isValid() ? moment.utc(data.value).local().format("L h:mm A") : "-"}</div>
            }
        ];

        const actions = [
            {
                id: "view",
                icon: "fa-eye",
                description: "View"
            },
            {
                id: "edit",
                icon: "fa-pencil",
                description: "Edit"
            },
            {
                id: "reset",
                icon: "fa-key",
                description: "Reset password",
                isHidden: (user) => user.realm !== "local"
            },
            {
                id: "delete",
                icon: "fa-trash",
                description: "Delete"
            },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewuser/${item.user_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updateuser/${item.user_id}`);
                break;

                case "reset":
                    this.resetConfirm(item.user_id, item.username);
                break;

                case "delete":
                    this.deleteConfirm(item.user_id, item.username);
                break;
            }
        }

        const onFetch = async (options) => {
            const userInfo = JSON.parse(window.localStorage.getItem("user_info") || "{}");

            const anonymousFilter = _.find(options.filters, { id: "anonymous" });
            const showAnonynoums = !anonymousFilter || !anonymousFilter.value || anonymousFilter.value === "true";
            const showAnonynoumsOnly = anonymousFilter && anonymousFilter.value === "true";

            const { users, page } = await http({
                url: `${__CLOUD_SERVER__}admin/get_users`, // eslint-disable-line
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    anonymous: showAnonynoums,
                    anonymous_only: showAnonynoumsOnly,
                    token: userInfo.token,
                    username: userInfo.username,
                    page: options.page,
                    page_size: options.pageSize,
                    filters: options.filters,
                    sort_by: options.sortBy,
                    sort_direction: options.sortDirection
                }),
            });

            this.setState({ users });

            return {
                items: users,
                page
            }
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                               <div className="title-head">
                               <i className="fa fa-user-circle-o"></i>
                                   <strong>Users</strong></div> 
                                <Link className="pull-right add-btn" to={{ pathname: "/createuser" }}>
                                    <button className="pull-right adduser-btn" >
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                         Add User 
                                    </button>
                                </Link> 
                            </CardHeader>
                            <CardBody className="p-0" >
                                <DataTable
                                    id="admin-user"
                                    columns={columns}
                                    actions={actions}
                                    onAction={onAction}
                                    onFetch={onFetch}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal  isOpen={this.state.modalreset} toggle={this.toggle1} className="user-modal">
                    <Form  onSubmit={handleSubmit(this.resetPassword)}>
                        <ModalHeader toggle={this.toggle1}> Reset Password
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <Row>
                                    <Col sm="6">
                                        <label className="requiredasterisk">New Password: </label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field 
                                            id="newPassword"
                                            type="password"
                                            name="newPassword"
                                            component={renderField} 
                                            validate={[required, password]}
                                        /> 
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm="6">
                                        <label className="requiredasterisk">Confirm Password:</label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field
                                            id="confirmPassword"
                                            type="password"
                                            name="confirmPassword"
                                            component={renderField}
                                            validate={[required, password]}
                                        />                                            
                                    </Col>
                                </Row>
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={this.toggle1}  className="cancel-button" size="sm" color="basic"> Cancel</Button>
                            <Button type="submit" size="sm" className="submit-button" color="primary">  Submit</Button>
                        </ModalFooter>
                    </Form>  
                </Modal>

                <Modal isOpen={this.state.modal} toggle={this.deleteConfirm} className="user-modal">
                    <ModalHeader toggle={this.deleteConfirm}>Are you sure you want to delete this user?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.toggle} className="cancel-button" size="sm" color="basic"> Close</Button>
                        <Button onClick={this.deleteUser} className="delete-button"  size="sm" color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}


AdminUser.propTypes = {
    updateUser: Proptypes.func.isRequired,
    history: Proptypes.object.isRequired,
    updateUsersError: Proptypes.func,
    updatErrorWarning: Proptypes.func,
    resetPasswordError: Proptypes.func,
    deleteUser: Proptypes.func.isRequired,
    resetPasswordFunc: Proptypes.func,
    errorResetPasswordMessage: Proptypes.string,
    deleteUsersError: Proptypes.func,
    deleteUserErrorMessage: Proptypes.func,
    getAdminUsers: Proptypes.func.isRequired,
    initialize: Proptypes.func,
    getUsersLoading: Proptypes.bool,
    users: Proptypes.array,
    handleSubmit:  Proptypes.func,
    className: Proptypes.object 
};

let  AdminUserFormWithRouter = withRouter(AdminUser);

let AdminUserForm = connect(state => {
    return ({
        users: state.admin.users || [],
        usersPage: state.admin.usersPage || 0,
        errorResetPasswordMessage: state.admin.errorResetPasswordMessage || null,
        updatErrorWarning: state.admin.updatErrorWarning || null,
        resetPasswordError: state.admin.resetPasswordError || null,
        deleteUsersError: state.admin.deleteUsersError || null,
        getUsersLoading: state.admin.getUsersLoading || false,
        deleteUserErrorMessage: state.admin.deleteUserErrorMessage || null,
        pages : {pageSize : state.admin.pageSize, pageNo : state.admin.pageNo},
    })
},
dispatch => 
    ({  
        getAdminUsers: (data) => dispatch(getAdminUsers(data)),
        resetPasswordFunc: (data) => dispatch(resetPasswordFunc(data)),
        updateUser: (data) => dispatch(updateUser(data)),
        deleteUser: (data) => dispatch(deleteUser(data)),
        setPageInfo : (data)=> dispatch(setPageInfo(data)),
    }))(AdminUserFormWithRouter);


export default reduxForm({
    form: "adminuserForm",
    validate
})(AdminUserForm);
